import { useState, useRef, useCallback, useMemo } from 'react'
import TrackerCalendarHeader from './TrackerCalenderHeader'
import TrackerCalendarContent from './TrackerCalendarContent'
import { Box } from '@mui/material'
import TrackerCalendarModal from './TrackerCalendarModal'
import TrackerCalendarDrawer from './TrackerCalendarDrawer'

export default function TrackerCalendar() {
    const [calendarValue, setCalendarValue] = useState(new Date())
    const [calendarFilter, setCalendarFilter] = useState({
        holiday: true,
        leave: true,
        birthday: true,
        anniversary: true,
    })

    const [selectedFilters, setSelectedFilters] = useState([])

    const selectedEmployees = useMemo(
        () => (selectedFilters || []).filter((item) => item?.type === 'employee'),
        [selectedFilters]
    )
    const selectedProjects = useMemo(
        () => (selectedFilters || []).filter((item) => item?.type === 'project'),
        [selectedFilters]
    )
    const isStaffMode = Boolean(selectedEmployees?.length)

    const apiFilter = useMemo(() => {
        return selectedEmployees.map((s) => s?.id).filter(Boolean)
    }, [selectedEmployees])

    const selectedProjectIds = useMemo(() => {
        return selectedProjects.map((p) => p?.id).filter(Boolean)
    }, [selectedProjects])

    const divRef = useRef([])

    const [dayModalOpen, setDayModalOpen] = useState(false)
    const [selectedDay, setSelectedDay] = useState(null)
    const [selectedDayProjects, setSelectedDayProjects] = useState([])

    const [drawerOpen, setDrawerOpen] = useState(false)
    const [selectedProjectId, setSelectedProjectId] = useState(null)

    const scrollToDiv = (index) => {
        if (divRef.current[index]) {
            divRef.current[index].scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
    }

    const handleMonth = useCallback((index) => scrollToDiv(index), [])

    const handleDayClick = useCallback((date, projectsInThatDay = []) => {
        setSelectedDay(date)
        setSelectedDayProjects(projectsInThatDay)
        setDayModalOpen(true)
    }, [])

    const handleEventClick = useCallback((project) => {
        setSelectedProjectId(project?.id)
        setDrawerOpen(true)
    }, [])

    const closeDayModal = useCallback(() => setDayModalOpen(false), [])
    const closeDrawer = useCallback(() => {
        setDrawerOpen(false)
        setSelectedProjectId(null)
    }, [])

    return (
        <div headerTitle="Calendar">
            <div>
                <Box display={'flex'} flexDirection={'column'} gap={2}>
                    <TrackerCalendarHeader
                        calendarValue={calendarValue}
                        setCalendarValue={setCalendarValue}
                        calendarFilter={calendarFilter}
                        setCalendarFilter={setCalendarFilter}
                        handleClick={handleMonth}
                        selectedFilters={selectedFilters}
                        setSelectedFilters={setSelectedFilters}
                    />

                    <TrackerCalendarContent
                        ref={divRef}
                        calendarValue={calendarValue}
                        filters={calendarFilter}
                        apiFilter={apiFilter}
                        selectedProjectIds={selectedProjectIds}
                        onDayClick={handleDayClick}
                        onEventClick={handleEventClick}
                        selectedEmployees={selectedEmployees}
                        isStaffMode={isStaffMode}
                    />
                </Box>

                <TrackerCalendarModal
                    open={dayModalOpen}
                    onClose={closeDayModal}
                    date={selectedDay}
                    projects={selectedDayProjects}
                    onProjectClick={(p) => {
                        closeDayModal()
                        handleEventClick(p)
                    }}
                    showMembers={isStaffMode}
                    members={isStaffMode ? selectedEmployees : []}
                />

                <TrackerCalendarDrawer open={drawerOpen} onClose={closeDrawer} projectId={selectedProjectId} />
            </div>
        </div>
    )
}
